export type NgxDatum = {
  name: string;
  value: number;
  originalName?: string;
};

export function toNgxData(input: unknown[], nameKey = 'name', valueKey = 'value'): NgxDatum[] {
  if (!Array.isArray(input)) return [];
  const out: NgxDatum[] = [];
  for (const row of input) {
    const rawName = (row as any)?.[nameKey];
    const name = (rawName === null || rawName === undefined) ? '' : String(rawName);
    const valueNum = Number((row as any)?.[valueKey]);
    if (!Number.isFinite(valueNum)) continue;
    out.push({ name, value: valueNum });
  }
  return out;
}
